import Row from '@components/Row';
import styled from '@emotion/styled';

interface Props {
    total: number;
    current: number;
    className?: string;
}

function Indicator({ total, current, className }:Props) {
    return (
        <Row className={className}
            spacing={2}
            aria-label='indicator' >
            {Array.from({ length: total }).map((_, i) => (
                <Dot isActive={i === current}
                    key={`indicator${i}`} />
            ))}
        </Row>
    );
}

const Dot = styled('div', {
    shouldForwardProp: (prop) => prop !== 'isActive',
})<{
    isActive: boolean;
}>`
    background-color: var(--color-icon-${({ isActive }) => (isActive ? 'default' : 'unselected')});
    border-radius: var(--radius-full);
    height: var(--spacing-1-5);
    width: var(--spacing-1-5);
    transition: background-color 100ms;
`;

export default Indicator;
